import { adStatuses, REFRESH_INTERVAL } from "./status"
import { googletag } from "./shared"
import { ADS } from "./constants"
import { isPlayerInFullscreen } from "../../new_player/player-fullscreen-util"

const queueRefresh = (slot, path) => {
  console.log(`Queuing refresh for ${path} of ${REFRESH_INTERVAL}s`)

  setTimeout(function () {
    if (isPlayerInFullscreen()) {
      console.log(`Player in fullscreen, skipping refresh for ${path}`)
      queueRefresh(slot, path)
    } else {
      console.log(`Refreshing ${path}`)
      googletag.pubads().refresh([slot])
    }
  }, REFRESH_INTERVAL * 1000)
}

export const displayAd = (key) => {
  const ad = ADS[key]
  const { id, shouldRefresh } = ad
  const status = adStatuses[key]
  if (status && status.initialized && !status.filled) {
    googletag.cmd.push(function () {
      if (!document.getElementById(id)) {
        return
      }

      googletag.display(id)
      status.filled = true

      googletag.pubads().addEventListener("impressionViewable", function (event) {
        const slot = event.slot

        if (!shouldRefresh) {
          return
        }

        if (slot.getTargeting(id).indexOf("true") > -1) {
          queueRefresh(slot, status.activePath)
        }
      })
    })
  }
}

export const displayAds = () => {
  Object.keys(ADS).forEach((key) => {
    displayAd(key)
  })
}

displayAds()
